import Vue from 'vue';
import Vuex from 'vuex';

import limit from './modules/limit';
import filter from './modules/filter';
import wkMap from './modules/worksheetMap';
import customInfo from './modules/customInfo';
import global from './modules/global';
import alarmFilters from './modules/alarmFilters';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    limit,
    filter,
    wkMap,
    customInfo,
    alarmFilters
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js